import { PurchaseBudgetRow, SalesBudgetRow } from "./BudgetImport";
import { getSessionAuthentication, rms2BasePath } from "../../common/Api";

export async function saveSalesBudgetImport(salesBudgetRows: SalesBudgetRow[]) {
    const request = { "SalesBudgets": salesBudgetRows };
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const serializedRequest = JSON.stringify(request);
    const fullPath = rms2BasePath + 'budgets/import/sale';

    console.log("POSTing to path: ", fullPath);

    const response = await fetch(fullPath, {
        method: "POST",
        headers: requestHeaders,
        body: serializedRequest
    });

    if (!response.ok) throw new Error(`saveSalesBudgetImport failed: ${response.status} ${response.statusText}`);

    return response.body;
}

export async function savePurchaseBudgetImport(purchaseBudgetRows: PurchaseBudgetRow[]) {
    const request = { "PurchaseBudgets": purchaseBudgetRows };
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const serializedRequest = JSON.stringify(request);
    const fullPath = rms2BasePath + 'budgets/import/purchase';

    console.log("POSTing to path: ", fullPath);

    const response = await fetch(fullPath, {
        method: "POST",
        headers: requestHeaders,
        body: serializedRequest
    });

    if (!response.ok) throw new Error(`savePurchaseBudgetImport failed: ${response.status} ${response.statusText}`);

    return response.body;
}

export type BudgetType = {
    id: number,
    budgetDescription: string,
    budgetSystemType: number
}

export type SalesBudgetTypesResponse = {
    salesBudgetTypes: BudgetType[]
}

export type PurchaseBudgetTypesResponse = {
    purchaseBudgetTypes: BudgetType[]
}

export async function getPurchaseBudgetTypes(): Promise<BudgetType[]> {
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const fullPath = rms2BasePath + 'budgets/purchasebudgettypes';

    const response = await fetch(fullPath, {
        method: "GET",
        headers: requestHeaders
    });

    const purchaseBudgetTypesResponse = await response.json() as PurchaseBudgetTypesResponse;

    return purchaseBudgetTypesResponse.purchaseBudgetTypes;
}

export async function getSalesBudgetTypes(): Promise<BudgetType[]> {
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const fullPath = rms2BasePath + 'budgets/salesbudgettypes';

    const response = await fetch(fullPath, {
        method: "GET",
        headers: requestHeaders
    });

    const salesBudgetTypesResponse = await response.json() as SalesBudgetTypesResponse;

    return salesBudgetTypesResponse.salesBudgetTypes;
}

export async function getItemGroupCodes(): Promise<string[]> {
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const fullPath = rms2BasePath + 'budgets/itemGroupCodes';

    const response = await fetch(fullPath, {
        method: "GET",
        headers: requestHeaders
    });

    const data = await response.json() as { itemGroupCodes: string[] };
    return data.itemGroupCodes;
}

export async function getLocationNumbers(): Promise<number[]> {
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const fullPath = rms2BasePath + 'budgets/locationNumbers';

    const response = await fetch(fullPath, {
        method: "GET",
        headers: requestHeaders
    });

    const data = await response.json() as { locationNumbers: number[] };
    return data.locationNumbers;
}

export async function downloadSalesBudgetTemplate(): Promise<void> {
    const auth = getSessionAuthentication();
    const response = await fetch(rms2BasePath + 'budgets/import/sale/template', {
        headers: constructBaseHeaders(auth.token, auth.tenantStringIdentifier)
    });
    if (!response.ok) throw new Error(`Failed to download template: ${response.status}`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'DagsFsg-BudgetMall.xlsx';
    a.click();
    URL.revokeObjectURL(url);
}

export async function downloadPurchaseBudgetTemplate(): Promise<void> {
    const auth = getSessionAuthentication();
    const response = await fetch(rms2BasePath + 'budgets/import/purchase/template', {
        headers: constructBaseHeaders(auth.token, auth.tenantStringIdentifier)
    });
    if (!response.ok) throw new Error(`Failed to download template: ${response.status}`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Inköps-BudgetMall.xlsx';
    a.click();
    URL.revokeObjectURL(url);
}

export async function getCollectionCodes(): Promise<number[]> {
    const auth = getSessionAuthentication();
    const requestHeaders = constructBaseHeaders(auth.token, auth.tenantStringIdentifier);
    const fullPath = rms2BasePath + 'budgets/collectionCodes';

    const response = await fetch(fullPath, {
        method: "GET",
        headers: requestHeaders
    });

    const data = await response.json() as { collectionCodes: number[] };
    return data.collectionCodes;
}

function constructBaseHeaders(sessionToken: string, tenantStringIdentifier: string): {
    "Content-Type": string,
    "Authorization": string,
    "X-CleverApps-Tenant": string
} {
    return {
        "Content-Type": "application/json",
        "Authorization": sessionToken,
        "X-CleverApps-Tenant": tenantStringIdentifier
    };
}
